var exports = {
  "k": "xe564cbfb--66ea12--container",
  "w": "xe564cbfb--66ea12--loader",
};

module.exports = exports;
